import Vue          from "vue";
import {BootstrapVue, IconsPlugin} from "bootstrap-vue";
import Vuelidate    from "vuelidate";

import app      from "@/app";
import router   from "@/config/router";
import store    from "@/store/store";
import api      from "@/lib/api";
import helper   from "@/lib/helper";

import "@/plugins/portal-vue";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);

let wkCookie = document.cookie.match(/TAC_PBT_WEBKEY=\S+/);
if (!wkCookie) {
    let currentUrl = window.location.href;
    //window.location = 'https://identity.industrysoftware.automation.siemens.com/WebkeyLogin/Authenticate?url=' + currentUrl;
}
    
(async function () {
    try {
        console.log("call helper");
        await helper.setWebkeyHelperCookies();
    }
    catch (e) {
        console.log(e);
    }
    
    try {
        let resp = await api.webkey.get();
//        console.log("committing wk", resp.data);
        store.commit("webkey", resp.data);
    }
    catch (e) {
        let error_time_stamp = e.response && e.response.data ? e.response.data.timestamp : null;
        store.commit("timeStamp", error_time_stamp);
        store.commit("webkey", null);
    }

    new Vue({
        router,
        store,
        render: (h) => h(app),
    }).$mount("#app");
})();